import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AssociationService} from "./services/association.service";

@Component({
    selector: 'app-association-form',
    templateUrl: './association-form.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationFormComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    unitBases:any = {};
    conditionTypes:any = {};
    integerLogics:any = {};

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private parameterService: ParameterService,
        private associationService: AssociationService,
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            associationName: [null, [Validators.required]],
            email: [null, [Validators.required]],
            website: [null, [Validators.required]],
            phone: [null, [Validators.required]],
            address: [null, [Validators.required]],
            registeredOn: [null, [Validators.required]],
            status: [true, [Validators.required]],
            activities: this.formBuilder.array([])
        });

        this.addActivity();
        this.addCondition(0);
    }

    get activities(): FormArray {
        return this.form.get('activities') as FormArray;
    }

    createActivity(): FormGroup {
        return this.formBuilder.group({
            activityType: [null, [Validators.required]],
            ceuValue: [null, [Validators.required]],
            unitBase: [null, [Validators.required]],
            note: [null, [Validators.required]],
            conditions: this.formBuilder.array([]),
            completionQuestion: [null, [Validators.required]],
        })
    }

    addActivity() {
        this.activities.push(this.createActivity());
    }

    removeActivity(i: number) {
        if(this.activities.length > 1) {
            this.activities.removeAt(i);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining activity');
            return;
        }

    }

    conditions(activityIndex: number): FormArray {
        return this.activities.at(activityIndex).get('conditions') as FormArray;
    }

    addCondition(activityIndex: number) {
        const conditionFG = this.formBuilder.group({
            conditionName: [null, [Validators.required]],
            conditionType: ['BOOLEAN', [Validators.required]],
            integerOperator: ['GT', []],
            valueIfValid: ['true', [Validators.required]],

        });

        this.conditions(activityIndex).push(conditionFG);
    }

    removeCondition(activityIndex: number, conditionIndex: number) {
        const conditions = this.activities.at(activityIndex).get('conditions') as FormArray;
        if(conditions.length > 1) {
            conditions.removeAt(conditionIndex);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining condition');
            return;
        }
    }

    changeConditionType(i: number, j: number) {
        const conditions = this.activities.at(i).get('conditions') as FormArray;
        if(conditions.at(j).get('conditionType').value == "INTEGER") {
            conditions.at(j).get('valueIfValid').setValue(1);
        }

    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");
    }

    saveAssociation() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Save New Association",
                subMessage: "Are you sure want to save association?",
                buttonOkLabel: 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.associationService.save(this.form.value).then(r => {
                    this.showAlertDark('Association', 'Association has been saved successfully', '');
                    this.router.navigate(['/office/association']).then();
                })
            }
        })
    }

}
